import { render, staticRenderFns } from "./CheckoutPersonalData.vue?vue&type=template&id=f1761446"
import script from "./CheckoutPersonalData.vue?vue&type=script&lang=js"
export * from "./CheckoutPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports